module.exports = __webpack_public_path__ + "static/img/Bachelor_010257.1f780fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010257.jpg
// module id = 130
// module chunks = 0